import React, { useEffect, useState } from 'react';
import { Button, Grid } from '../../shared';
import { Section, FilterSelect, InputSearch } from '../../shared';
import './product-table.scss';
import { LoaderWrapper } from '../../../shared/utils/loader/loader-wrapper';
import { useLoader } from '../../../shared/utils';
export var ProductTable = function (_a) {
    var _b;
    var productList = _a.productList, productCategories = _a.productCategories, rateTypes = _a.rateTypes, handleKey = _a.handleKey, pageFunction = _a.pageFunction, sortFunction = _a.sortFunction, rateTypeChangeHandler = _a.rateTypeChangeHandler, productListChangeHandler = _a.productListChangeHandler, selectedProductCategory = _a.selectedProductCategory, selectedRateType = _a.selectedRateType, noRowsMessage = _a.noRowsMessage, isFilterValueChanged = _a.isFilterValueChanged, setIsFilterValueChanged = _a.setIsFilterValueChanged;
    var _c = useState(1), pageCount = _c[0], setPageCount = _c[1];
    var _d = useState([]), ProductListData = _d[0], setProductData = _d[1];
    var Columns = [
        {
            id: 'description',
            description: 'Product',
            sort: false,
        },
        {
            id: 'productTypeId',
            description: 'Rate Type',
            sort: false,
            render: function (column, row) {
                return React.createElement(React.Fragment, null, row[column.id] === 1 ? 'Fixed' : 'Variable');
            },
        },
        { id: 'loanPurpose', description: 'Loan Purpose', sort: false },
        { id: 'productCode', description: 'Product Code', sort: false },
        { id: 'displayInitialRate', description: '% Initial Rate', sort: false },
        { id: 'displayStandardVariableRate', description: '% Subsequent Rate', sort: false },
        { id: 'ltv', description: '% LTV', sort: false },
        {
            id: 'displayProductFee',
            description: 'Product Fee',
            sort: false,
        },
        {
            id: 'url',
            description: 'More Info',
            render: function (column, row) {
                var _a;
                return ((_a = row[column.id]) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (React.createElement("a", { href: "".concat(row[column.id]), target: "_blank", rel: "noreferrer", className: "info-link" },
                    React.createElement(Button, { type: "button", variant: "bare", icon: "info", iconPosition: "left" }, "Info"))) : undefined;
            },
            sort: false,
        },
    ];
    var productTableIsLoading = useLoader({ identifier: 'productTable' }).productTableIsLoading;
    useEffect(function () {
        var _a;
        var count = 1;
        if (productList && productList.length > 0)
            count = ((_a = productList[0]) === null || _a === void 0 ? void 0 : _a.pageCount) || 1;
        setPageCount(count);
        setProductData(productList);
    }, [productList]);
    return (React.createElement(Section, { headerChildren: React.createElement("div", { className: "c-product" },
            React.createElement("div", null,
                React.createElement(FilterSelect, { id: "rate-type", required: false, forceSelection: true, placeHolder: "Rate type", value: selectedRateType, options: rateTypes === null || rateTypes === void 0 ? void 0 : rateTypes.map(function (rateType) { return ({
                        id: rateType.id,
                        value: rateType.name,
                    }); }), onChange: rateTypeChangeHandler })),
            React.createElement("div", null,
                React.createElement(FilterSelect, { id: "product-list", required: false, forceSelection: true, value: selectedProductCategory, placeHolder: "Product Category", options: (_b = productCategories === null || productCategories === void 0 ? void 0 : productCategories.map(function (prod) { return ({
                        id: prod.id,
                        value: prod.name,
                    }); })) !== null && _b !== void 0 ? _b : [], onChange: productListChangeHandler })),
            React.createElement("div", { className: "c-search-add" },
                React.createElement(InputSearch, { id: "search-clients", onKeyUp: handleKey }))) },
        React.createElement(LoaderWrapper, { type: "table", identifier: "productTable" },
            React.createElement(Grid, { pageSize: 10, rowData: productTableIsLoading ? [] : ProductListData, columns: Columns, maxPage: pageCount, gotoPage: pageFunction, sortRows: sortFunction, extendClass: "c-product-table", noRowsMessage: noRowsMessage, defaultSortColumn: "description", defaultDirection: "Asc", isFilterValueChanged: isFilterValueChanged, setIsFilterValueChanged: setIsFilterValueChanged }))));
};
